import React from 'react';

const ContactFormFormModal = React.lazy(() => import('../components/FormModal'));
const contactFormModalRegistry = {
    core_contactFormId: ContactFormFormModal
};
export default contactFormModalRegistry;
